import { useEffect, useRef } from "react";
import { useMe } from "../me";
import { useLaunchDarklyFlags } from "./ClientSideLDProvider";

export const MARKETPLACE_FEATURE_FLAG = "chau-146-new-marketplace";

export const useLaunchDarkly = () => {
  const { ldClient } = useLaunchDarklyFlags();
  const me = useMe();
  const hasIdentified = useRef(false);
  const isMountedRef = useRef(true);

  // Cleanup: mark as unmounted
  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    // Skip if already identified, no client, or user data not yet fetched
    if (hasIdentified.current || !ldClient || !me.hasFetched) {
      return;
    }

    const user = {
      kind: "user", // Explicitly set context kind for SDK v3
      key: me.id,
      anonymous: false,
      email: me.email,
      firstName: me.firstName,
      lastName: me.lastName,
      // Custom attributes for targeting
      chauffeurId: me.id,
      businessDistrict: me.lsp?.businessDistrict?.name || null,
    };

    ldClient
      .identify(user)
      .then(() => {
        // Only update ref if component is still mounted
        if (isMountedRef.current) {
          hasIdentified.current = true;
        }
      })
      .catch((error: Error) => {
        console.error(
          `[LaunchDarkly] Failed to identify user. key: ${user.key ?? "unknown"}, businessDistrict: ${user.businessDistrict ?? "none"}`,
          error,
        );
      });
  }, [
    ldClient,
    me.hasFetched,
    me.id,
    me.email,
    me.firstName,
    me.lastName,
    me.lsp,
  ]);
};
